// Access token bellekte tutulur (sekme yenilenince silinir). Refresh token artık
// httpOnly cookie'de (JS erişemez); backend set/clear eder. Böylece sayfa yenilense
// veya backend yeniden başlasa da oturum cookie üzerinden kurtarılır — localStorage'da
// refresh token tutulmaz (XSS yüzeyi daralır, transient hatada token silinmez).

let accessToken: string | null = null

export function getAccessToken(): string | null {
  return accessToken
}

export function setAccessToken(token: string | null): void {
  accessToken = token
}

export function clearAccessToken(): void {
  accessToken = null
}
